import React from 'react';
import Proptypes from 'prop-types';
import i18n from 'i18n';

// External components
import { Modal } from 'antd';

// Styles
import './ModalDetalhesUpload.scss';

function ModalDetalhesUpload({ upload, visible, toggleVisible }) {
  function closeModal() {
    toggleVisible(false);
  }

  return (
    <Modal
      className="modal-detalhes-upload"
      title={i18n.t('Detalhes da importação de {{type}}', {
        type: upload?.params?.type,
      })}
      visible={visible}
      width={600}
      footer={null}
      onCancel={closeModal}
    >
      <div>
        <h4>{i18n.t('Parâmetros utilizados')}:</h4>
        <pre>{JSON.stringify(upload?.params, null, 2)}</pre>
      </div>
    </Modal>
  );
}

ModalDetalhesUpload.propTypes = {
  visible: Proptypes.bool.isRequired,
  toggleVisible: Proptypes.func.isRequired,
  upload: Proptypes.object,
};

ModalDetalhesUpload.defaultProps = {
  upload: null,
};

export default ModalDetalhesUpload;
